import { TableHeader, type TableHeaderRow } from '@shared/table-generator';

const headers: TableHeaderRow[] = [
  {
    children: [
      {
        id: 'questionType',
        children: 'Question Type',
        align: 'center',
        rowSpan: 2,
        sx: {
          minWidth: '128px',
        },
      },
      {
        id: 'calculated',
        children: 'คำนวณ',
        align: 'center',
        colSpan: 3,
      },
      {
        id: 'not-calculated',
        children: 'ไม่คำนวณ',
        align: 'center',
        colSpan: 3,
      },
    ],
  },
  {
    children: [
      {
        children: 'ง่าย',
        align: 'center',
      },
      {
        children: 'กลาง',
        align: 'center',
      },
      {
        children: 'ยาก',
        align: 'center',
      },
      {
        children: 'ง่าย',
        align: 'center',
      },
      {
        children: 'กลาง',
        align: 'center',
      },
      {
        children: 'ยาก',
        align: 'center',
        sx: {
          borderRight: 'none',
        },
      },
    ],
  },
];

export function SingleQuestionConditionsTableHeader() {
  return (
    <TableHeader
      columns={headers}
      slotProps={{
        tableHeader: {
          sx: (theme) => ({
            bgcolor: theme.palette.common.black,
            borderColor: theme.palette.grey[300],
            border: 'none',
          }),
        },
        tableHeaderRow: {
          sx: {
            ':first-of-type': {
              'th:last-of-type': {
                borderRight: 'none',
              },
            },
            ':last-of-type > th': {
              borderTop: '1px solid',
              borderColor: (theme) => theme.palette.grey[300],
            },
          },
        },
        tableHeaderCell: {
          sx: (theme) => ({
            ...theme.typography.body1Semibold,
            color: theme.palette.common.white,
            backgroundColor: theme.palette.common.black,
            padding: theme.spacing(2, 3),
            borderRight: '1px solid',
            borderBottom: 'none',
            borderColor: theme.palette.grey[300],
          }),
        },
      }}
    />
  );
}
